// extracted by mini-css-extract-plugin
export var backdropBlur = "_kl-0";
export var contentCard = "_kl-5";
export var frame = "_kl-2";
export var image = "_kl-4";
export var imagePane = "_kl-3";
export var modal = "_kl-1";